import React from "react";
import "./Comfort_Guage.css";
import Common_Title from "../../common_components/common_title/Common_Title";
function Comfort_Guage() {
  return (
    <div className="comfort_banner container luxery-section">
       <div className="title_with_line">
           <Common_Title title="Comfort Guage" />
      </div>

      <img
        src="/assets/images/hospitality/img.png"
        alt="Comfort Banner"
        className="comfort_img"
      />
    </div>
  );
}

export default Comfort_Guage;
